
import { computed, defineComponent } from 'vue'
import {
  getFileIconInfo,
  resolveFileDisplayName,
} from '@/utils/chatFile'

export default defineComponent({
  name: 'ChatFileAttachment',
  props: {
    url: {
      type: String,
      required: true,
    },
    fileName: {
      type: String,
      default: '',
    },
    msgType: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const displayName = computed(() =>
      resolveFileDisplayName(props.url, props.fileName)
    )

    const iconInfo = computed(() =>
      getFileIconInfo(displayName.value, props.msgType)
    )

    return {
      displayName,
      iconInfo,
    }
  },
})
